package com.mvlikhachev.app.presentation.screen.base

data class ResultScreenValues(
    val message: String = "",
    val buttonText: String? = null,
    val opacity: Boolean = false,
    val duration: Long = 1000L,
    val doAfter: (() -> Unit)? = null
)